<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h3 class="title">{{ $t('Customer') }}</h3>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
            <v-btn color="grey" outline>
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <i class="fas fa-file-export"></i>
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="importCustomer">
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}
            </v-btn>
            <v-btn color="grey" outline @click="exportCustomer(0)">
              <i class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}
            </v-btn>
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <i class="fas fa-angle-down" v-if="!showAdvance"></i>
          <i class="fas fa-angle-up" v-else></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee;border-radius: 10px;position: relative;"
    >
      <template>
        <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          style="border-radius: 10px;"
        ></v-premium-plan-popup>
        <filter-customer v-model="filter">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed @click="onSearch" color="primary">
            <i class="fas fa-search mr-1"></i>
            {{ $t('Search') }}
          </v-btn>
        </filter-customer>
      </template>
    </div>

    <v-data-table
      :loading="loading"
      :headers="filteredHeader"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <customer-item v-model="props.item"></customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
    </v-data-table>

    <div class="text-xs-center mt-4">
      <v-btn
        outline
        color="primary"
        :loading="loading"
        :disabled="!hasNext"
        @click="getMoreCustomers"
        >{{ $t('Next') }}</v-btn
      >
    </div>
  </v-container>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Multiselect from 'vue-multiselect'
import CustomerItem from './CustomerItem'
import { mapGetters } from 'vuex'
import FilterCustomer from '@/components/elements/FilterCustomer'

export default {
  data: function() {
    return {
      headers: [
        { text: '', sortable: false },
        { text: this.$t('name'), value: 'first_name' },
        { text: this.$t('Channel'), value: 'app' },
        { text: this.$t('gender'), value: 'gender' },
        { text: this.$t('Register Date'), value: 'registertimestamp' },
        { text: this.$t('Last Active Date'), value: 'timestamp' },
        { text: this.$t('Email'), value: 'email' },
        { text: this.$t('phone no.'), value: 'phoneno' },
        { text: this.$t('Status'), value: 'status' },
        { text: this.$t('Message Sent'), value: 'messagesent' },
        { text: this.$t('Locale'), value: 'locale' },
        { text: this.$t('Lineid'), value: 'lineid' },
        { text: this.$t('Province'), value: 'province' },
        { text: this.$t('School'), value: 'school' },
        { text: '', sortable: false }
      ],
      pagination: { rowsPerPage: -1 },
      tag: '',
      singleStatus: '',
      showAdvance: false,
      users: [],
      limit: 100,
      offset: 0,
      hasNext: true,
      count: 0,
      gendercount: '',
      users_count: [],
      intents: [],
      delayImport: false,
      search: '',
      filter: {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        email: '',
        phoneno: '',
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        status: '',
        tags: '',
        lineid: '',
        school: '',
        province: ''
      },
      loading: true,
      errorFilterTag: [],
      errorFilterStatus: [],
      customerfromfb: null
    }
  },
  components: {
    ScaleLoader,
    CustomerItem,
    PulseLoader,
    Multiselect,
    FilterCustomer
  },
  mounted: async function() {
    var vm = this
    vm.getIntent(function() {
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function() {
          vm.loading = false
        }
      )
    })
    vm.$store.dispatch('loadStatus')
  },
  computed: {
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filteredHeader() {
      if (this.isBU) return this.headers
      else {
        return this.headers.filter(v => {
          return !['lineid', 'province', 'school'].includes(v.value)
        })
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    pageid: function() {
      return this.$store.state.selectedBot.pageid
    },
    filterIntent: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function(index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      }
    },
    status: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.status && vm.filter.status !== '') {
          var status = []
          status = vm.filter.status.split(',')
          var result = []
          if (status) {
            status.map(function(s, index) {
              result.push({ text: s })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(s, index) {
            result.push(s.text)
          })
        }
        vm.filter.status = result.join(',')
      }
    }
  },
  methods: {
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 20) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function(newTags) {
      this.tags = newTags
    },
    checkStatus(obj) {
      this.errorFilterStatus = []
      if (obj.tag.text.length > 20) {
        this.errorFilterStatus.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterStatus.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addStatus: function(newTags) {
      this.status = newTags
    },
    clearSearch: function() {
      this.filter = {
        fullname: '',
        gender: {
          label: this.$t('All'),
          value: 'all'
        },
        locale: null,
        app: {
          label: this.$t('All'),
          value: 'all'
        },
        intent: null,
        messagesent: {
          value: null,
          symbol: {
            value: 'g__',
            label: this.$t('Greater than')
          }
        },
        timezone: {
          from: -12,
          to: 14
        },
        activeDate: {
          enable: false,
          start: null,
          end: null
        },
        registerDate: {
          enable: false,
          start: null,
          end: null
        },
        tags: '',
        status: ''
      }
      this.$forceUpdate()

      this.onSearch()
    },
    onSearch: function() {
      var vm = this
      vm.$validator.validate().then(result => {
        if (!result) {
          vm.goToErrorInput()
          return false
        }
        vm.offset = 0
        vm.hasNext = true
        vm.users = []
        vm.loading = true
        vm.getLoadUsers(vm.limit, vm.offset).then(
          function(users) {
            vm.users = vm.users.concat(users)
            vm.loading = false
          },
          function(error) {
            vm.loading = false
          }
        )
      })
    },
    getLoadUsers: function(limit, offset) {
      let vm = this
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.pageid,
          grouptype: vm.grouptype,
          filter: vm.filter,
          limit: limit,
          offset: offset
        }

        api.getAllUsers(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (vm.limit > response.data.length) {
            vm.hasNext = false
          }

          var users = response.data
          resolve(users)
        })
      })
    },
    getMoreCustomers: function() {
      var vm = this
      vm.loading = true
      vm.getLoadUsers(vm.limit, vm.offset).then(
        function(users) {
          vm.offset += vm.limit
          vm.users = vm.users.concat(users)
          vm.loading = false
        },
        function(error) {
          vm.loading = false
        }
      )
    },
    onFailLoad: function(index) {
      this.$set(this.users[index], 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return moment(date).format(format)
    },
    onActiveStartDate: function(value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
    },
    onActiveEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
    },
    onRegisterStartDate: function(value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
    },
    onRegisterEndDate: function(value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.pageid
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var isFoundDefault = false
          $.each(response.data, function(index, val) {
            var intent = val
            intent.isShow = false
            vm.intents.push(intent)
          })
        }
        callback()
      })
    },
    exportCustomer: function(offset = 0) {
      let vm = this
      let csvContent = ''

      var limit = 50000
      vm.loading = true

      vm.getLoadUsers(limit, offset).then(
        function(users) {
          if (users && users.length > 0) {
            csvContent += 'ID,Name,Channel,Gender,Register Date,Last Active Date'

            if (vm.$store.getters.getPackage == 'premium') {
              csvContent += ',Email,Phone No,Status,Tag,Message Sent'
            }

            csvContent += ',Locale'

            if (vm.$store.getters.getPackage == 'premium') {
              csvContent += ',Intent'
            }

            csvContent += '\r\n'

            $.each(users, function(index, val) {
              let row = ''
              if (vm.$store.getters.getPackage == 'premium') {
                row += '"' + (val.id ? val.id : '-') + '",'
              } else {
                row += '"premium",'
              }

              row +=
                '"' +
                (
                  (val.first_name ? val.first_name : '') +
                  ' ' +
                  (val.last_name ? val.last_name : '')
                ).replace(/\r?\n|\r/g, ' / ') +
                '",'
              row += '"' + val.app + '",'
              row += '"' + val.gender + '",'
              row +=
                '"' +
                (val.registertimestamp ? moment(val.registertimestamp).format('DD/MM/YYYY') : '-') +
                '",'
              row += '"' + (val.timestamp ? moment(val.timestamp).format('DD/MM/YYYY') : '-') + '",'
              if (vm.$store.getters.getPackage == 'premium') {
                row += '"' + (val.email ? val.email : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row +=
                  (val.phoneno ? '="' + val.phoneno.replace(/\r?\n|\r/g, ' / ') + '"' : '""') + ','
                row += '"' + (val.status ? val.status : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row += '"' + (val.tags ? val.tags : '').replace(/\r?\n|\r/g, ' / ') + '",'
                row += '"' + (val.messagesent ? val.messagesent : '') + '",'
              }
              row += '"'
              config.locale.find(function(locale) {
                if (val.locale == locale.value) {
                  row += locale.title
                  return false
                }
              })
              row += '",'
              if (vm.$store.getters.getPackage == 'premium') {
                row += '"' + (val.intentlist ? val.intentlist.join(',') : '') + '"'
              }

              csvContent += row + '\r\n'
            })

            vm.exportCsv(csvContent, 'customer_' + offset)

            offset += limit
            if (users.length >= limit) {
              vm.exportCustomer(offset)
            } else {
              vm.loading = false
            }
          } else {
            vm.loading = false
          }
        },
        function() {
          vm.loading = false
        }
      )
    },
    importCustomer: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to import customer?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var data = {
              pageid: vm.selectedBot.pageid
            }
            vm.loading = true
            vm.offset = 0
            vm.hasNext = true
            vm.users = []
            api.insertUsersFromInbox(data, function(error, response) {
              if (error) {
                vm.loading = false
                return
              }
              vm.getLoadUsers(vm.limit, vm.offset).then(
                function(users) {
                  vm.users = vm.users.concat(users)

                  vm.delayImport = true
                  vm.$swal.fire({
                    title: vm.$t('Import customer successful'),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                  vm.loading = false
                },
                function(error) {
                  vm.loading = false
                }
              )
            })
          }
        })
    }
  },
  watch: {
    count: function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$emit('onUserLoaded', vm.count)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Customers.vue